/**
 * COMMERCE-WORKSPACE-FRAMEWORK-000001 — bulk selection action bar slot content.
 */
import type { ReactNode } from 'react';

const btn =
  'inline-flex min-h-11 items-center rounded-[var(--shell-radius-md)] border border-[var(--shell-border)] bg-[var(--shell-surface-elevated)] px-3 text-sm text-[var(--shell-fg)] hover:bg-[var(--shell-hover)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--shell-focus-ring)]';

export function BulkActionBar({
  selectedCount,
  children,
  message,
}: {
  selectedCount: number;
  children: ReactNode;
  message?: string;
}) {
  if (selectedCount <= 0) return null;
  return (
    <>
      <span className="text-xs font-medium text-[var(--shell-fg-muted)]">
        {selectedCount} selected
      </span>
      {children}
      {message ? (
        <span className="text-xs text-[var(--shell-fg-muted)]" aria-live="polite">
          {message}
        </span>
      ) : null}
    </>
  );
}

export function BulkActionButton({
  children,
  onClick,
  disabled,
}: {
  children: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
}) {
  return (
    <button type="button" className={btn} onClick={onClick} disabled={disabled}>
      {children}
    </button>
  );
}

export const bulkActionButtonClassName = btn;
